import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // important!

const Header = () => {
  const [userRole, setUserRole] = useState(localStorage.getItem('role'));
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const checkRole = () => setUserRole(localStorage.getItem('role'));
    checkRole();
    window.addEventListener('storage', checkRole);
    return () => window.removeEventListener('storage', checkRole);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('role');
    localStorage.removeItem('token');
    setUserRole(null);
    navigate('/login');
    window.dispatchEvent(new Event('storage'));
  };

  const closeNavbar = () => {
    const navbar = document.getElementById('navbarCollapse');
    if (navbar && navbar.classList.contains('show')) {
      const bsCollapse = new window.bootstrap.Collapse(navbar, { toggle: true });
      bsCollapse.hide();
    }
  };

  useEffect(() => {
    const checkRole = () => setUserRole(localStorage.getItem('role'));
    checkRole();
    window.addEventListener('storage', checkRole);

    // Auto-close dropdown when item is clicked
    const dropdownItems = document.querySelectorAll('.dropdown-menu .dropdown-item');
    dropdownItems.forEach(item => {
      item.addEventListener('click', closeNavbar);
    });

    return () => {
      window.removeEventListener('storage', checkRole);
      dropdownItems.forEach(item => {
        item.removeEventListener('click', closeNavbar);
      });
    };
  }, []);

  return (
    // <div style={{ position: 'sticky', top: 0, zIndex: 1000,width: '100vw' }}>

    <div className="bg-dark">
      <div className="row py-2 px-lg-5">
        <div className="col-lg-5 ms-3 text-lg-left mb-2 mb-lg-0">
          <div className="container-fluid p-0 m-0">
            <div
              className="d-inline-flex align-items-center text-white"
              style={{ fontSize: '16px' }}
            >
              <small><i className="fa fa-phone-alt mr-2"></i>+91 7892343219</small>
              <small className="px-3">|</small>
              <small><i className="fa fa-envelope mr-2"></i>retools@retools.in</small>
            </div>
          </div>

        </div>
        <div className="col-lg-2 text-center ms-auto text-lg-right" style={{ position: 'relative' }}>

          <div className="d-inline-flex align-items-center">
            <a className="text-white px-2" href="#"><i className="fab fa-facebook-f"></i></a>
            <a className="text-white px-2" href="#"><i className="fab fa-twitter"></i></a>
            <a className="text-white px-2" href="#"><i className="fab fa-linkedin-in"></i></a>
            <a className="text-white px-2" href="#"><i className="fab fa-instagram"></i></a>
            <a className="text-white pl-2" href="#"><i className="fab fa-youtube"></i></a>
          </div>
        </div>
      </div>

      <div className="container-fluid p-0">
        <nav className="navbar navbar-expand-lg bg-white navbar-light py-3 py-lg-0 px-lg">
          <Link to="/" className="navbar-brand ml-lg-3 d-lg-none d-flex align-items-center">
            <img src="/assets/img/logg.jpeg" alt="Logo" style={{ height: '60px' }} />
          </Link>
          <nav className="navbar navbar-expand-lg navbar-light px-3">
            {/* Mobile Header Row (visible only on small screens) */}
            <div className="d-flex justify-content-between align-items-center w-100 d-lg-none px-3">
              {/* Hamburger Icon (Left) */}
              <button
                className="navbar-toggler border-0"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>

              {/* Three Vertical Dots Icon (Right) */}
              <button className="border-0 bg-transparent">

              </button>
            </div>

            {/* Desktop Brand (visible on lg and up) */}
            <Link to="/" className="navbar-brand d-none d-lg-flex align-items-center">
  <img
    src="/assets/img/logg.jpeg"
    alt="Logo"
    style={{ height: '60px', marginRight: '10px' }}
  />
  <span style={{ fontSize: '20px', fontWeight: 'bold', color: '#333' }}>
   RAMESH ENTERPRISES
  </span>
</Link>

            {/* Collapsible Menu */}
            <div className="collapse navbar-collapse justify-content-between" id="navbarCollapse">
              {/* Your nav items go here */}
            </div>
          </nav>


          <div className="collapse navbar-collapse justify-content-between px-lg-3" id="navbarCollapse">
            <div className="navbar-nav mx-auto py-0">
              <Link to="/#" className={`nav-item nav-link${location.pathname === '/' ? ' active' : ''}`} onClick={closeNavbar}>Home</Link>
              <Link to="/about" className={`nav-item nav-link${location.pathname === '/about' ? ' active' : ''}`} onClick={closeNavbar}>About</Link>
              {/* <Link to="/Gallerry" className={`nav-item nav-link${location.pathname === '/Gallerry' ? ' active' : ''}`} onClick={closeNavbar}>Gallery</Link> */}
              {/* <Link to="/Testishow" className={`nav-item nav-link${location.pathname === '/Testishow' ? ' active' : ''}`} onClick={closeNavbar}>Testinomails</Link> */}

              {/* <div className="nav-item dropdown">
                <a href="#" className={`nav-link dropdown-toggle${location.pathname.startsWith('/sap') || location.pathname === '/Sappm' || location.pathname === '/sapps' ? ' active' : ''}`} role="button" data-bs-toggle="dropdown">Courses</a>
                <div className="dropdown-menu m-0">
                  <Link to="/sapfin" className={`dropdown-item${location.pathname === '/sapfin' ? ' active' : ''}`} onClick={closeNavbar}>SAP Finance and Controlling</Link>
                  <Link to="/sapmm" className={`dropdown-item${location.pathname === '/sapmm' ? ' active' : ''}`} onClick={closeNavbar}>SAP Material Management</Link>
                  <Link to="/sapHcm" className={`dropdown-item${location.pathname === '/sapHcm' ? ' active' : ''}`} onClick={closeNavbar}>Human Resource Management</Link>
                  <Link to="/Sappm" className={`dropdown-item${location.pathname === '/Sappm' ? ' active' : ''}`} onClick={closeNavbar}>SAP Plant Maintenance</Link>
                  <Link to="/sapps" className={`dropdown-item${location.pathname === '/sapps' ? ' active' : ''}`} onClick={closeNavbar}>Project Systems</Link>
                  <Link to="/sappp" className={`dropdown-item${location.pathname === '/sappp' ? ' active' : ''}`} onClick={closeNavbar}>Production Planning</Link>
                  <Link to="/sapsd" className={`dropdown-item${location.pathname === '/sapsd' ? ' active' : ''}`} onClick={closeNavbar}>Sales and Distribution</Link>
                  <Link to="/sapab" className={`dropdown-item${location.pathname === '/sapab' ? ' active' : ''}`} onClick={closeNavbar}>SAP ABAP</Link>
                </div>
              </div> */}

              
              <Link to="/blog" className={`nav-item nav-link${location.pathname === '/blog' ? ' active' : ''}`} onClick={closeNavbar}>Buy From Us</Link>
              <Link to="/Sells" className={`nav-item nav-link${location.pathname === '/Sells' ? ' active' : ''}`} onClick={closeNavbar}>Supply to Us</Link>
              <Link to="/careers" className={`nav-item nav-link${location.pathname === '/careers' ? ' active' : ''}`} onClick={closeNavbar}>Join From Us</Link>
              <Link to="/Contact" className={`nav-item nav-link${location.pathname === '/Contact' ? ' active' : ''}`} onClick={closeNavbar}>Contact</Link>
<div className='d-flex align-items-center' style={{ gap: '80px',position: 'relative',  }}>
              {userRole === 'admin' && (
                <Link to="/jobpost" className={`nav-item nav-link${location.pathname === '/jobpost' ? ' active' : ''}`} onClick={closeNavbar}>Admin</Link>
              )}  
              {userRole ? (
                <Link onClick={handleLogout} className=" btn btn-danger py-2 px-4">
                Logout
              </Link>
            ) : (
              <Link to="/login" className={`${location.pathname === '/login' ? ' active' : ''}`}>
               
              </Link>
            )}
            </div>
            </div>

          
          </div>
        </nav>
      </div>
    </div>
    // </div>
  );
};

export default Header;
